module.exports = __webpack_public_path__ + "img/b1c6de5.png";